var React = require('react');

function ExternalLinkDeprecated (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"fill":"currentColor","d":"M12.528 11.51h5.482a.25.25 0 0 1 .25.25v2a.25.25 0 0 1-.25.25h-5.442l.05 3.126a.25.25 0 0 1-.427.181L7.804 12.93a.25.25 0 0 1 0-.353l4.25-4.249a.25.25 0 0 1 .426.173l.048 3.01z","id":"external-link"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},React.createElement("use",{"fill":"currentColor","transform":"scale(-1 1) rotate(45 0 -18.417)","xlinkHref":"#external-link"}))]);
}

ExternalLinkDeprecated.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = ExternalLinkDeprecated;

ExternalLinkDeprecated.default = ExternalLinkDeprecated;
